(function (root) {
  'use strict';

  function shuffle(items) {
    for (var i = items.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var item = items[i];
      items[i] = items[j];
      items[j] = item;
    }
    return items;
  }

  function apply(container) {
    if (!container || !container.getAttribute) return;

    var mode = container.getAttribute('data-sweet-mischen');
    var children = Array.prototype.slice.call(container.children);

    if (mode === 'gruppe') {
      shuffle(children).forEach(function (child) {
        container.appendChild(child);
      });
    }

    if (mode === 'satzweise') {
      var count = parseInt(container.getAttribute('data-sweet-mischen-saetze'), 10);
      if (!count || count < 1 || children.length % count) return;

      var length = children.length / count;
      var order = shuffle(Array.from({ length: length }, function (_, index) { return index; }));
      var reordered = [];

      for (var group = 0; group < count; group += 1) {
        for (var index = 0; index < length; index += 1) {
          reordered.push(children[group * length + order[index]]);
        }
      }

      reordered.forEach(function (child) {
        container.appendChild(child);
      });
    }
  }

  if (root) {
    root.SweetMischen = root.SweetMischen || {};
    root.SweetMischen.shuffle = shuffle;
    root.SweetMischen.apply = apply;
  }

  if (!root || typeof document === 'undefined') return;

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sweet-mischen]'), apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}(typeof window === 'undefined' ? null : window));
